module.exports = __webpack_public_path__ + "img/collection-diamondJewelryWhitegold@2x.9eda652.jpg";